/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Gender_MaleInputs */

const en_voice_manager_gender_male = /** @type {(inputs: Voice_Manager_Gender_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`male`)
};

const fr_voice_manager_gender_male = /** @type {(inputs: Voice_Manager_Gender_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`masculin`)
};

const de_voice_manager_gender_male = /** @type {(inputs: Voice_Manager_Gender_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`männlich`)
};

const it_voice_manager_gender_male = /** @type {(inputs: Voice_Manager_Gender_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`maschio`)
};

const ru_voice_manager_gender_male = /** @type {(inputs: Voice_Manager_Gender_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`мужской`)
};

const es_voice_manager_gender_male = /** @type {(inputs: Voice_Manager_Gender_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`masculino`)
};

const zh_cn2_voice_manager_gender_male = /** @type {(inputs: Voice_Manager_Gender_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`男性`)
};

const ja_voice_manager_gender_male = /** @type {(inputs: Voice_Manager_Gender_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`男`)
};

const hi_voice_manager_gender_male = /** @type {(inputs: Voice_Manager_Gender_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुरुष`)
};

const pt_pt2_voice_manager_gender_male = /** @type {(inputs: Voice_Manager_Gender_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macho`)
};

/**
* | output |
* | --- |
* | "male" |
*
* @param {Voice_Manager_Gender_MaleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_gender_male = /** @type {((inputs?: Voice_Manager_Gender_MaleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Gender_MaleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_gender_male(inputs)
	if (locale === "de") return de_voice_manager_gender_male(inputs)
	if (locale === "it") return it_voice_manager_gender_male(inputs)
	if (locale === "ru") return ru_voice_manager_gender_male(inputs)
	if (locale === "es") return es_voice_manager_gender_male(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_gender_male(inputs)
	if (locale === "ja") return ja_voice_manager_gender_male(inputs)
	if (locale === "hi") return hi_voice_manager_gender_male(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_gender_male(inputs)
	return en_voice_manager_gender_male(inputs)
});